// # === Single Role ===
const OnlyAdmin = ["ADMIN"];
const OnlyStoreManager = ["STORE"];
const OnlyEmployee = ["EMPLOYEE"];
const OnlyAuditor = ["AUDITOR"];
const OnlyHOD = ["HOD"];
const OnlyLocationManager = ["LOCATION"];

// # === Admin + Combinations ===
const AdminStore = ["ADMIN", "STORE"];
const AdminEmployee = ["ADMIN", "EMPLOYEE"];
const AdminHOD = ["ADMIN", "HOD"];
const AdminAuditor = ["ADMIN", "AUDITOR"];
const AdminLocation = ["ADMIN", "LOCATION"];

// # === Multi-role Groups ===
const LocationStoreManager = ["STORE", "LOCATION"];
const AdminAuditorLocation = ["ADMIN", "LOCATION", "AUDITOR"];
const AdminStoreEmployee = ["ADMIN", "STORE", "EMPLOYEE"];
const AdminHODEmployee = ["ADMIN", "HOD", "EMPLOYEE"];
const AdminStoreHOD = ["ADMIN", "STORE", "HOD"];
const AdminAllOps = ["ADMIN", "STORE", "HOD", "EMPLOYEE", "LOCATION"];
const FullAccessRoles = [
  "ADMIN",
  "EMPLOYEE",
  "HOD",
  "STORE",
  "LOCATION",
  "AUDITOR",
];
const ExcepEmployeeHOD = ["ADMIN", "STORE", "AUDITOR", "LOCATION"];
const ExcepEmployeeAdmin = ["STORE", "AUDITOR", "LOCATION", "HOD"];
const ExcepEmployee = ["ADMIN", "STORE", "AUDITOR", "LOCATION", "HOD"];

export {
  OnlyAdmin,
  OnlyAuditor,
  OnlyEmployee,
  OnlyHOD,
  OnlyLocationManager,
  OnlyStoreManager,
  AdminStore,
  AdminEmployee,
  AdminHOD,
  AdminAuditor,
  AdminLocation,
  AdminStoreEmployee,
  AdminHODEmployee,
  AdminStoreHOD,
  AdminAllOps,
  FullAccessRoles,
  ExcepEmployeeHOD,
  ExcepEmployeeAdmin,
  LocationStoreManager,
  AdminAuditorLocation,
  ExcepEmployee,
};
